import { createFileRoute } from '@tanstack/react-router'
import { EmailConfirmPage } from '~/features/auth/EmailConfirmPage'

export const Route = createFileRoute('/email-bestaetigen')({
  validateSearch: (s: Record<string, unknown>): { token?: string } =>
    typeof s.token === 'string' && /^[\w-]{10,200}$/.test(s.token) ? { token: s.token } : {},
  component: function EmailConfirm() {
    return <EmailConfirmPage token={Route.useSearch().token} />
  },
})
